// extracted by mini-css-extract-plugin
export default {"send-msg-form":"SendMsgForm_send-msg-form__qgZZg"};